export function getTokenStorageKey(subdomain: string) {
  return `token${subdomain}`;
}

export function getVaultViewStorageKey(subdomain: string) {
  return `vaultView${subdomain}`;
}

export function getCreatorOnboardingHiddenStorageKey(subdomain: string) {
  return `creatorOnboardingHidden${subdomain}`;
}

export function loadToken(subdomain: string) {
  return window.localStorage.getItem(getTokenStorageKey(subdomain)) ?? "";
}

export function saveToken(subdomain: string, token: string) {
  window.localStorage.setItem(getTokenStorageKey(subdomain), token);
}

export function clearToken(subdomain: string) {
  window.localStorage.removeItem(getTokenStorageKey(subdomain));
}

export function loadVaultView(subdomain: string) {
  return window.localStorage.getItem(getVaultViewStorageKey(subdomain)) ?? "creator";
}

export function saveVaultView(subdomain: string, view: "creator" | "user") {
  window.localStorage.setItem(getVaultViewStorageKey(subdomain), view);
}

export function clearVaultView(subdomain: string) {
  window.localStorage.removeItem(getVaultViewStorageKey(subdomain));
}

export function loadCreatorOnboardingHidden(subdomain: string) {
  return window.localStorage.getItem(getCreatorOnboardingHiddenStorageKey(subdomain)) === "1";
}

export function saveCreatorOnboardingHidden(subdomain: string) {
  window.localStorage.setItem(getCreatorOnboardingHiddenStorageKey(subdomain), "1");
}

export function clearCreatorOnboardingHidden(subdomain: string) {
  window.localStorage.removeItem(getCreatorOnboardingHiddenStorageKey(subdomain));
}
